ready = ->
  $("body").on "click", ".add-species-btn", (e) ->
    $('#edit_species').addClass 'hide'
    $('#register_species').removeClass 'hide'

  $("body").on "click", ".edit-species-btn", (e) ->
    $('#edit_species').removeClass 'hide'
    $('#register_species').addClass 'hide'

$(document).on 'turbolinks:load', ready